import fetchKitchens from "./fetchKitchens";
import fetchProfiles from "./fetchProfiles";

export default [...fetchKitchens, ...fetchProfiles];
